import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import style from './Tab.module.scss';

export default function Tab(props) {
  const { active, activeClassName, className, title, onClick, testId } = props;

  return (
    <a
      href="#"
      onClick={onClick}
      className={classnames(style.link, className, {
        [style.active]: active,
        [activeClassName]: active,
      })}
      data-testid={testId}
    >
      {title}
    </a>
  );
}

Tab.propTypes = {
  /**
   * active state
   */
  active: PropTypes.bool.isRequired,
  /**
   * title of the tab
   */
  title: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.element.isRequired,
  ]),
  /**
   * function to run on click
   */
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  /**
   * value of `data-testid` property to set on the tab link
   */
  testId: PropTypes.string,
};

Tab.defaultProps = {
  title: '',
  testId: null,
  className: '',
  activeClassName: '',
};

Tab.displayName = 'Tab';
